module.exports = __webpack_public_path__ + "img/de1lay.806ec96e.png";